import { apiFetch } from "./client";
import type { Cse, Page } from "./types";
import type { ListParams } from "./customers";

export interface CsePayload {
  cse_code: string;
  name: string;
  surname: string;
  phone?: string | null;
  email?: string | null;
  address?: string | null;
  parent_id?: number | null;
  on_holiday_from?: string | null;
  on_holiday_to?: string | null;
}

export interface CseOverviewCustomer {
  id: number;
  customer_no: string;
  name: string;
  address: string | null;
  postcode: string | null;
  phone_numbers: string[];
  contact_emails: string[];
  cse_id?: number | null;
  cse_code?: string | null;
  cse_name?: string | null;
  cse_active?: boolean;
}

export interface CseOverviewEntry {
  id: number;
  cse_code: string;
  name: string;
  surname: string;
  email: string | null;
  phone: string | null;
  on_holiday_from: string | null;
  on_holiday_to: string | null;
  is_active: boolean;
}

export interface CseOverview {
  cses: CseOverviewEntry[];
  assigned: CseOverviewCustomer[];
  unassigned: CseOverviewCustomer[];
}

export async function getCseOverview(): Promise<CseOverview> {
  return apiFetch<CseOverview>("/cse/overview");
}

export async function listCse(params: ListParams = {}): Promise<Page<Cse>> {
  const qs = new URLSearchParams();
  if (params.limit !== undefined) qs.set("limit", String(params.limit));
  if (params.offset !== undefined) qs.set("offset", String(params.offset));
  const query = qs.toString();
  return apiFetch(`/cse${query ? `?${query}` : ""}`);
}

export async function createCse(data: CsePayload): Promise<Cse> {
  return apiFetch("/cse", { method: "POST", body: JSON.stringify(data) });
}

export async function getCse(id: number): Promise<Cse> {
  return apiFetch(`/cse/${id}`);
}

export async function updateCse(id: number, data: Partial<CsePayload>): Promise<Cse> {
  return apiFetch(`/cse/${id}`, { method: "PUT", body: JSON.stringify(data) });
}

export async function deleteCse(id: number): Promise<unknown> {
  return apiFetch(`/cse/${id}`, { method: "DELETE" });
}
